import { render, staticRenderFns } from "./AiResponse.vue?vue&type=template&id=6a1a5966&scoped=true"
import script from "./AiResponse.vue?vue&type=script&lang=js"
export * from "./AiResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1a5966",
  null
  
)

export default component.exports